import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled, { keyframes } from "styled-components";

const slideUpMweb = keyframes`
  from {
    transform: translateY(calc(100% + 12px));
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideUpDweb = keyframes`
  from {
    transform: translateX(-50%) translateY(calc(100% + 12px));
    opacity: 0;
  }
  to {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
`;

export const DiscountBannerWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 12px 20px;
  border-radius: 16px;
  border: 1px solid transparent;
  background:
    linear-gradient(180deg, #fcfbff 0%, #ebfbee 100%) padding-box,
    linear-gradient(170deg, #0b753e 0%, #ebfbee 30%) border-box;
  backdrop-filter: blur(25px);
  box-sizing: border-box;
`;

/** Slide-up on the fixed banner (fixed children don’t give outer wrapper height). */
export const DiscountBannerWrapperSlideUp = styled(DiscountBannerWrapper)<{
  $isDesktop?: boolean;
}>`
  animation: ${({ $isDesktop }) =>
      $isDesktop ? slideUpDweb : slideUpMweb}
    0.55s cubic-bezier(0.22, 1, 0.36, 1) forwards;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 1;
    transform: none;
  }
`;

export const DiscountBannerIcon = styled.img`
  width: 40px;
  height: 40px;
  flex: 0 0 24px;
  aspect-ratio: 1/1;
`;

export const DiscountBannerText = styled.div<{
  isTitleOnly?: boolean;
  $isDesktop?: boolean;
}>`
  display: flex;
  flex-direction: ${({ $isDesktop }) => ($isDesktop ? "row" : "column")};
  flex-wrap: wrap;
  gap: ${({ $isDesktop }) => ($isDesktop ? "6px" : "4px")};
  align-items: ${({ isTitleOnly }) => (isTitleOnly ? "center" : "flex-start")};
  text-align: ${({ isTitleOnly }) => (isTitleOnly ? "center" : "left")};
`;

export const DiscountBannerTitle = styled(Text)<{
  $isDesktop: boolean;
  $hasStrikeOff?: boolean;
}>`
  color: var(--Text-Primary-grey600, #121212);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;

  span.discount-green {
    color: var(--Green-G400, #0b753e);
  }

  ${({ $hasStrikeOff }) =>
    $hasStrikeOff &&
    `
    span:not(.discount-green) {
      color: var(--Text-Tertiary-grey300, #757575);
      font-family: 'Euclid Circular B', 'Inter', sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      text-decoration-line: line-through;
    }
  `}
`;

export const DiscountBannerSubtitle = styled(Text)<{ $isDesktop: boolean }>`
  color: var(--Text-Primary-grey600, #121212);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
